import produce from 'immer';
import cloneDeep from 'lodash/cloneDeep';

import { createReducer } from 'utils/redux';

import type {
  CcmCampaignAction,
  CcmCampaignState
} from '../types';

const EMPTY_STATE: CcmCampaignState = {
  campaign: null,
  timeline: null,
  pool: null,
  metadata: null,
  outfitPerformance: null,
  outfitPerformanceCountries: [],
  screenState: {
    page: 1,
    totalItems: 0,
    links: {},
    meta: {}
  },
  ccmLegalRequirementsTemplate: ''
};

const initialState = cloneDeep(EMPTY_STATE);

export default createReducer<CcmCampaignState, CcmCampaignAction>(
  'ccmCampaign',
  initialState,
  {
    'ccm-campaign-create': (state, { campaign }) => produce(
      state, draft => {
        draft.campaign = campaign;
      }
    ),
    'ccm-campaign-update': (state, { campaign }) => produce(
      state, draft => {
        draft.campaign = campaign;
      }
    ),
    'ccm-campaign-approve': (state, { campaign }) => produce(
      state, draft => {
        draft.campaign = campaign;
      }
    ),
    'ccm-campaign-timeline-generated': (state, { timeline }) => produce(
      state, draft => {
        draft.timeline = timeline;
      }
    ),
    'ccm-campaign-timeline-flush': state => produce(
      state, draft => {
        draft.timeline = null;
      }
    ),
    'ccm-campaign-pool-get': (state, { pool }) => produce(
      state, draft => {
        draft.pool = pool;
      }
    ),
    'ccm-campaign-pool-flush': (state) => produce(
      state, draft => {
        draft.pool = null;
      }
    ),
    'ccm-campaign-screen-state-updated': (state, { screenState }) => produce(
      state, draft => {
        draft.screenState = screenState;
      }
    ),
    'ccm-campaign-pagination-updated': (state, { meta, links }) => produce(
      state, draft => {
        draft.screenState.meta = meta;
        draft.screenState.links = links;
      }
    ),
    'ccm-campaign-metadata-patch': (state, { metadata }) => produce(
      state, draft => {
        draft.metadata = metadata;
      }
    ),
    'ccm-campaign-outfit-performance-get': (state, { outfitPerformance }) => produce(
      state, draft => {
        draft.outfitPerformance = outfitPerformance;
      }
    ),
    'ccm-campaign-outfit-performance-countries-update': (state, { outfitPerformanceCountries }) => produce(
      state, draft => {
        draft.outfitPerformanceCountries = outfitPerformanceCountries;
      }
    ),
    'ccm-campaign-assets-loaded': (state, { ccmLegalRequirementsTemplate }) => produce(
      state, draft => {
        draft.ccmLegalRequirementsTemplate = ccmLegalRequirementsTemplate;
      }
    )
  }
);
